import { render, staticRenderFns } from "./ModalClassficacaoJustificativa.vue?vue&type=template&id=112eedca&scoped=true"
import script from "./ModalClassficacaoJustificativa.vue?vue&type=script&lang=js"
export * from "./ModalClassficacaoJustificativa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112eedca",
  null
  
)

export default component.exports